//copy function
export default function copy(text, el) {
  return new Promise((resolve, reject) => {
    if (
      document.queryCommandSupported &&
      document.queryCommandSupported('copy')
    ) {
      let dialog;

      console.log('queryCommandSupported: copy');
      if (el) {
        el.select();
      } else {
        dialog = document.querySelector('[role="dialog"]');
        var textArea = document.createElement('textarea');
        textArea.value = text;

        // Avoid scrolling to bottom
        textArea.style.top = '-100px';
        textArea.style.left = '-50px';
        textArea.style.position = 'fixed';
        if (dialog) {
          dialog.appendChild(textArea);
        } else {
          document.body.appendChild(textArea);
        }
        textArea.select();
      }
      try {
        //select it even though I have a function for that...
        // document.getElementById('selectable').select();
        const success = document.execCommand('copy');
      } catch (ex) {
        console.warn('Copy to clipboard failed.', ex);
        reject();
      }
      if (!el) {
        dialog
          ? dialog.removeChild(textArea)
          : document.body.removeChild(textArea);
      }

      resolve(true); // Security exception may be thrown by some browsers.
    } else if (window.clipboardData && window.clipboardData.setData) {
      console.log('clipboardData');
      //select it even though I have a function for that...
      // document.getElementById('selectable').select();
      // IE specific code path to prevent textarea being shown while dialog is visible.
      resolve(clipboardData.setData('Text', text));
    } else {
      reject(false);
    }
  });
}
